import { render, staticRenderFns } from "./mobileorderhistory.vue?vue&type=template&id=b0c8f942&"
import script from "./mobileorderhistory.vue?vue&type=script&lang=js&"
export * from "./mobileorderhistory.vue?vue&type=script&lang=js&"
import style0 from "./mobileorderhistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports